// extracted by mini-css-extract-plugin
module.exports = {"landingBoxSection":"LandingBoxSection_landingBoxSection___tvna","icon":"LandingBoxSection_icon__UYvDY"};